// src/utils/bgStyle.js
// Returns an inline style object with a background image from /public/images/
// Works correctly with Create React App (avoids CSS url() resolution issues)

const BASE = process.env.PUBLIC_URL || '';

const grad = (opacity = 0.6) =>
  `linear-gradient(135deg, rgba(255,255,255,0.7) 0%, rgba(255,249,235,${opacity}) 100%)`;

export const bgStyle = (filename, opacity = 0.6) => ({
  backgroundImage: `${grad(opacity)}, url("${BASE}/images/team/${encodeURIComponent(filename)}")`,
  backgroundSize: 'cover',
  backgroundPosition: 'center',
  backgroundRepeat: 'no-repeat',
});

export const BACKGROUNDS = {
  hero:       bgStyle('image copy 11.png', 0.45),
  about:      bgStyle('image copy 6.png'),
  mission:    bgStyle('image copy 5.png'),
  protection: bgStyle('image copy 9.png'),
  cta:        bgStyle('image copy 10.png'),
  contact:    bgStyle('image copy 10.png'),
};
